var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('div',{staticClass:"wrap1200"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }